<template>
  <div class="self-withdrawal-page" :class="client === 'iOS' ? 'iosBox' : ''">
    <div class="sw-header-spacer" aria-hidden="true"></div>
    <div class="sw-header-fixed">
      <div class="sw-header-inner">
        <img
          class="sw-back"
          src="../../assets/withdrawal_v2/back2.png"
          alt=""
          @click="goBack"
        />
        <p class="sw-title">{{ $t("guild_self_withdraw") }}</p>
      </div>
    </div>

    <SelfWithdrawalPanel :parent-coin="coin" />
  </div>
</template>

<script>
import SelfWithdrawalPanel from "@/components/withdrawal/self-withdrawal-panel.vue";

export default {
  name: "self-withdrawal",
  components: {
    SelfWithdrawalPanel,
  },
  // 页面基础状态：客户端类型与可提现余额
  data() {
    return {
      client: "PC",
      coin: 0,
    };
  },
  // 初始化：从路由读取余额、初始化语言并判断客户端类型
  created() {
    // 从路由参数读取可提现余额（去掉千分位逗号）
    const cin = this.$route.query.cin;
    if (cin) {
      this.coin = Number(String(cin).replace(/,/g, "")) || 0;
    }
    this.initLang();
    this.judgeClient();
    document.title = this.$t("guild_self_withdraw");
  },
  methods: {
    // 初始化 i18n 语言：将缓存/浏览器语言映射到支持的语言码并同步 html lang
    initLang() {
      const raw = localStorage.getItem("data");
      if (!raw) return;
      try {
        const data = JSON.parse(raw);
        const lang = data.lang || navigator.language;
        const langs = lang.substring(0, 2);
        if (langs === "zh") {
          this.$i18n.locale =
            lang === "zh-TW" || lang === "zh-HK" ? "tc" : "zh";
        } else if (langs === "en") {
          this.$i18n.locale = "en";
        } else if (langs === "ar") {
          this.$i18n.locale = "ar";
        } else if (langs === "tr") {
          this.$i18n.locale = "tr";
        } else if (langs === "es") {
          this.$i18n.locale = "es";
        } else if (langs === "pt") {
          this.$i18n.locale = "pt";
        } else if (langs === "fr") {
          this.$i18n.locale = "fr";
        } else if (langs === "id") {
          this.$i18n.locale = "id";
        } else if (langs === "ms") {
          this.$i18n.locale = "ms";
        } else {
          this.$i18n.locale = "en";
        }
        document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        } catch (e) {
        /* ignore */
      }
    },
    // 判断当前平台类型：iOS / Android / PC（用于样式适配）
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        this.client = "iOS";
      } else if (/(Android)/i.test(navigator.userAgent)) {
        this.client = "Android";
      } else {
        this.client = "PC";
      }
    },
    // 返回：无上一页时关闭 webview，否则路由返回
    goBack() {
      if (window.history.length <= 1) {
        this.$completes.complete("getPreviousPage");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped>
.self-withdrawal-page {
  min-height: 100vh;
  background: #f5f6f8;
  font-family: "Mada", sans-serif;
}

.sw-header-spacer {
  height: calc(88px + env(safe-area-inset-top));
  height: calc(88px + constant(safe-area-inset-top));
}

.sw-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
  background: #f5f6f8;
}

.sw-header-inner {
  position: relative;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
}

.sw-back {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
}

.sw-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  color: #262427;
}

html[lang="ar"] .self-withdrawal-page {
  direction: rtl;
}

html[lang="ar"] .sw-back {
  left: auto;
  right: 28px;
  transform: translateY(-50%) rotateY(180deg);
}
</style>
